// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: "Noto Sans JP", sans-serif;
  color: #393939;
  background: #FAF9F6;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Roboto", sans-serif;
}

.ant-btn-primary {
  border-color: #35be99;
}

.ant-divider {
  box-sizing: border-box;
  padding: 0;
  padding-right: 0px;
  padding-left: 0px;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  border-top: 2px solid #e8e3d5 !important;
}

.ant-divider-horizontal {
  display: flex;
  clear: both;
  width: 100%;
  min-width: 100%;
  margin: 15px 0;
}

.ant-btn-primary {
  background-color: #2a9679;
  border-radius: 12px;
}

.ant-btn-primary:hover {
  background-color: #248269;
}

.ant-radio-checked .ant-radio-inner {
  border-color: #6564DB;
}

.ant-radio-checked .ant-radio-inner:after {
  background-color: #6564DB;
}

.ant-radio:hover .ant-radio-inner {
  border-color: #6564DB;
}

.ant-checkbox-checked .ant-checkbox-inner {
  background-color: #6564DB;
  border-color: #6564DB;
}

.label-text {
  display: flex;
  text-align: center;
  flex-direction: column;
  font-size: 1rem;
  font-weight: 600;
}

.kbl-btn-3 {
  background-color: #6564DB !important;
  color: #FAF9F6 !important;
}

.kbl-table {
  overflow: hidden;
  border-radius: 10px;
  box-shadow: 0 0.0925rem 0.165rem rgba(0, 0, 0, 0.19);
  border: none;
  width: 100%;
  margin-bottom: 1rem;
  caption-side: bottom;
  border-collapse: collapse;
  --bs-table-color: none;
  --bs-table-bg: none;
}
.kbl-table .kbl-thead {
  background-color: #6564DB;
  border-bottom: 1px solid #c9c9c9;
  color: #FAF9F6;
}
.kbl-table .kbl-thead .human {
  background: #3c3bd1;
}
.kbl-table .kbl-thead .bottom {
  color: #393939;
}
.kbl-table .kbl-thead .bottom .light {
  background: #8e8de5;
}
.kbl-table .kbl-thead .bottom .dark {
  background: #ffe4eb;
}
.kbl-table tr {
  border-bottom: 1px solid #c9c9c9;
}
.kbl-table tr.select {
  cursor: pointer;
}
.kbl-table tr:last-child {
  border-bottom: none !important;
}
.kbl-table tr td.dark {
  background: #f1eee6;
}
.kbl-table tr:hover td {
  transition: 0.3s;
  background: #FAF9F6;
}
.kbl-table tr:hover td.light {
  background: #FAF9F6;
}
.kbl-table tr:hover td.dark {
  background: #f1eee6;
}

.desc {
  text-align: left;
  max-width: 100px;
}

.desc2 {
  text-align: left;
  max-width: 200px;
}

.table-responsive {
  max-height: 600px;
  padding: 5px 2px;
  border: none;
}

.pagination {
  margin: 15px auto;
  list-style: none;
  outline: none;
  display: inline-flex;
  padding-left: 0;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}

.pagination > .active > a {
  color: #FFFFFF;
}

.pagination > li > a {
  padding: 0.375rem 0.75rem;
  margin: 2px;
  position: relative;
  display: block;
  color: #2a9679;
  font-weight: 600;
  text-decoration: none;
  background-color: #FAF9F6;
  border: 1px solid #e8e3d5;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.pagination > li > a:hover {
  background-color: #6564DB;
  color: #FAF9F6 !important;
}

.pagination > .active > a,
.pagination > .active > span,
.pagination > .active > a:hover,
.pagination > .active > span:hover,
.pagination > .active > a:focus,
.pagination > .active > span:focus {
  z-index: 3;
  color: #FAF9F6;
  background-color: #2a9679;
  border-color: #35be99;
}

.pagination > li > a,
.pagination > li > span {
  color: #6564DB;
}

.pagination > li:first-child > a,
.pagination > li:first-child > span,
.pagination > li:last-child > a,
.pagination > li:last-child > span {
  border-radius: unset;
}

.pagi {
  align-content: center;
}

.pagination > li {
  background-color: #FAF9F6;
}

.loading {
  background-color: "transparent";
  backface-visibility: hidden;
}`, "",{"version":3,"sources":["webpack://./src/scss/style.scss","webpack://./src/scss/colors.scss","webpack://./src/scss/globals.scss"],"names":[],"mappings":"AAGA;EACE,uCAAA;EACA,cCoBU;EDnBV,mBCDU;ADDZ;;AAKA;;;;;;EAME,iCAAA;AAFF;;AAKA;EACE,qBCXgB;ADSlB;;AAKA;EACE,sBAAA;EACA,UAAA;EACA,kBAAA;EACA,iBAAA;EACA,0BAAA;EACA,eAAA;EACA,0BAAA;EACA,mBAAA;EACA,gBAAA;EACA,6BAAA;EACA,wCAAA;AAFF;;AAKA;EACE,aAAA;EACA,WAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;AAFF;;AAKA;EACE,yBC1CS;ED2CT,mBAAA;AAFF;;AAKA;EACE,yBC3Ce;ADyCjB;;AAKA;EACE,qBClDU;ADgDZ;;AAKA;EACE,yBCtDU;ADoDZ;;AAKA;EACE,qBC1DU;ADwDZ;;AAKA;EACE,yBC9DU;ED+DV,qBC/DU;AD6DZ;;AAKA;EACE,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;AAFF;;AAKA;EACE,oCAAA;EACA,yBAAA;AAFF;;AAKA;EACE,gBAAA;EACA,mBErFc;EFsFd,oDAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,oBAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;AAFF;AAIE;EACE,yBC5FQ;ED6FR,gCAAA;EACA,cC7FQ;AD2FZ;AAII;EACE,mBC5FW;AD0FjB;AAKI;EACE,cChFM;AD6EZ;AAKM;EACE,mBClGU;AD+FlB;AAMM;EACE,mBC/EO;AD2Ef;AASE;EACE,gCAAA;AAPJ;AASI;EACE,eAAA;AAPN;AAUI;EACE,8BAAA;AARN;AAWI;EACE,mBCtHW;AD6GjB;AAYI;EACE,gBAAA;EACA,mBCjIM;ADuHZ;AAYM;EACE,mBCpII;AD0HZ;AAaM;EACE,mBClIS;ADuHjB;;AAiBA;EACE,gBAAA;EACA,gBAAA;AAdF;;AAiBA;EACE,gBAAA;EACA,gBAAA;AAdF;;AAiBA;EACE,iBAAA;EACA,gBAAA;EACA,YAAA;AAdF;;AAiBA;EACE,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,qBAAA;AAdF;;AAiBA;EACE,cC5KM;AD8JR;;AAiBA;EACE,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,cCnLS;EDoLT,gBAAA;EACA,qBAAA;EACA,yBCpLU;EDqLV,yBAAA;EACA,qIAAA;AAdF;;AAiBA;EACE,yBC3LU;ED4LV,yBAAA;AAdF;;AAiBA;;;;;;EAME,UAAA;EACA,cCrMU;EDsMV,yBCxMS;EDyMT,qBCpMgB;ADsLlB;;AAiBA;;EAEE,cC7MU;AD+LZ;;AAiBA;;;;EAIE,oBAAA;AAdF;;AAiBA;EACE,qBAAA;AAdF;;AAiBA;EACE,yBC3NU;AD6MZ;;AAiBA;EACE,+BAAA;EACA,2BAAA;AAdF","sourcesContent":["@import './colors';\n@import './globals';\n\nbody {\n  font-family: 'Noto Sans JP', sans-serif;\n  color: $text-main;\n  background: $palette-3;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-family: 'Roboto', sans-serif;\n}\n\n.ant-btn-primary {\n  border-color: $palette-1-light;\n}\n\n.ant-divider {\n  box-sizing: border-box;\n  padding: 0;\n  padding-right: 0px;\n  padding-left: 0px;\n  color: rgba(0,0,0,.85);\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.5715;\n  list-style: none;\n  font-feature-settings: \"tnum\";\n  border-top: 2px solid $palette-3-darker !important;\n}\n\n.ant-divider-horizontal {\n  display: flex;\n  clear: both;\n  width: 100%;\n  min-width: 100%;\n  margin: 15px 0;\n}\n\n.ant-btn-primary {\n  background-color: $palette-1;\n  border-radius: 12px;\n}\n\n.ant-btn-primary:hover {\n  background-color: $palette-1-dark;\n}\n\n.ant-radio-checked .ant-radio-inner {\n  border-color: $palette-2;\n}\n\n.ant-radio-checked .ant-radio-inner:after {\n  background-color: $palette-2;\n}\n\n.ant-radio:hover .ant-radio-inner {\n  border-color: $palette-2;\n}\n\n.ant-checkbox-checked .ant-checkbox-inner {\n  background-color: $palette-2;\n  border-color: $palette-2;\n}\n\n.label-text {\n  display: flex;\n  text-align: center;\n  flex-direction: column;\n  font-size: 1rem;\n  font-weight: 600;\n}\n\n.kbl-btn-3 {\n  background-color: $palette-2 !important;\n  color: $palette-3 !important;\n}\n\n.kbl-table {\n  overflow: hidden;\n  border-radius: $border-radius;\n  box-shadow: 0 .0925rem .165rem rgba(0, 0, 0, 0.19);\n  border: none;\n  width: 100%;\n  margin-bottom: 1rem;\n  caption-side: bottom;\n  border-collapse: collapse;\n  --bs-table-color: none;\n  --bs-table-bg: none;\n\n  .kbl-thead {\n    background-color: $palette-2;\n    border-bottom: 1px solid $color-light-grey;\n    color: $palette-3;\n\n    .human {\n      background: $palette-2-dark;\n    }\n\n    .bottom {\n      color: $text-main;\n\n      .light {\n        background: $palette-2-light;\n      }\n\n      .dark {\n        background: $palette-2-bg;\n      }\n    }\n  }\n\n  tr {\n    border-bottom: 1px solid $color-light-grey;\n\n    &.select {\n      cursor: pointer;\n    }\n\n    &:last-child {\n      border-bottom: none !important;\n    }\n\n    td.dark {\n      background: $palette-3-dark;\n    }\n\n    &:hover td {\n      transition: 0.3s;\n      background: $palette-3;\n\n      &.light {\n        background: $palette-3;\n      }\n\n      &.dark {\n        background: $palette-3-dark;\n      }\n    }\n  }\n}\n\n.desc {\n  text-align: left;\n  max-width: 100px;\n}\n\n.desc2 {\n  text-align: left;\n  max-width: 200px;\n}\n\n.table-responsive {\n  max-height: 600px;\n  padding: 5px 2px;\n  border: none;\n}\n\n.pagination {\n  margin: 15px auto;\n  list-style: none;\n  outline: none;\n  display: inline-flex;\n  padding-left: 0;\n  margin-top: .5rem;\n  margin-bottom: .5rem;\n}\n\n.pagination>.active>a {\n  color: $white;\n}\n\n.pagination>li>a {\n  padding: .375rem .75rem;\n  margin: 2px;\n  position: relative;\n  display: block;\n  color: $palette-1;\n  font-weight: 600;\n  text-decoration: none;\n  background-color: $palette-3;\n  border: 1px solid $palette-3-darker;\n  transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n}\n\n.pagination>li>a:hover {\n  background-color: $palette-2;\n  color: $palette-3 !important;\n}\n\n.pagination>.active>a,\n.pagination>.active>span,\n.pagination>.active>a:hover,\n.pagination>.active>span:hover,\n.pagination>.active>a:focus,\n.pagination>.active>span:focus {\n  z-index: 3;\n  color: $palette-3;\n  background-color: $palette-1;\n  border-color: $palette-1-light;\n}\n\n.pagination>li>a,\n.pagination>li>span {\n  color: $palette-2\n}\n\n.pagination>li:first-child>a,\n.pagination>li:first-child>span,\n.pagination>li:last-child>a,\n.pagination>li:last-child>span {\n  border-radius: unset\n}\n\n.pagi {\n  align-content: center;\n}\n\n.pagination>li {\n  background-color: $palette-3;\n}\n\n.loading {\n  background-color: 'transparent';\n  backface-visibility: hidden;    \n}","\n$black: #011627;\n$white: #FFFFFF;\n$palette-1:#2a9679;\n$palette-2: #6564DB;\n$palette-3: #FAF9F6;\n\n$palette-1-dark: darken($palette-1, 5%);\n$palette-1-light: lighten($palette-1, 10%);\n$palette-2-dark: darken($palette-2, 10%);\n$palette-2-light: lighten($palette-2, 10%);\n$palette-3-dark: darken($palette-3, 5%);\n$palette-3-darker: darken($palette-3, 10%);\n$palette-3-light: lighten($palette-3, 10%);\n\n$text-host: #F06543;\n$text-host-light: lighten($text-host, 15%);\n$text-pathogen: #A68F26;\n$text-pathogen-light: lighten($text-pathogen, 20%);\n\n$nav-outline: #ffffff;\n$nav-outline-hvr: #ffffff;\n\n$text-ghost: #b4b4b4;\n$text-light:#ffffff;\n$text-main: #393939;\n$text-hard: #212121;\n\n$color-light-grey: #c9c9c9;\n\n$palette-1-v-light: #abeef0;\n\n$palette-1-bg: #e2fcfc;\n$palette-2-bg: #ffe4eb;\n\n$chip-bg: #def5ff;\n$chip-font: #036778;\n\n$palette-1-pastel: #a9fafc;\n\n// $nav-back:#4fa2a2;\n$nav-back:#288DC2;","$border-radius: 10px;\n$big-radius: 16px;\n$radius-btn: 10px;\n$nav-radius: 12px;\n\n$fw-light: 300;\n$fw-medium: 400;\n$fw-heavy: 500;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
